import { useState } from 'react';

export default function useToken() {

    const getTokenData = () => {
        const tokenString = sessionStorage.getItem('token');
        return JSON.parse(tokenString);
    };

    const getToken = () => {
        const userToken = getTokenData();

        if (!userToken?.access_token) {
            return null;
        }

        let date = new Date(userToken.expires_at);
        let today = new Date();

        if (!Number.isNaN(date.getTime()) && date < today)
        {
            sessionStorage.removeItem('token');
            return null;
        }

        return userToken.access_token;
    };

    const saveToken = userToken => {
        if (!userToken) {
            sessionStorage.removeItem('token');
            setToken(null);
            return;
        }

        sessionStorage.setItem('token', JSON.stringify(userToken));
        setToken(userToken.access_token);
        window.location.reload();
    };

    const [token, setToken] = useState(getToken());
    const tokenData = getTokenData();

    return {
        setToken: saveToken,
        token,
        user: tokenData?.user,
        roles: tokenData?.user?.roles || [],
        permissions: tokenData?.user?.permissions || []
    }
}   
